import AppLayout from "../AppLayout";
import QuickSearch from "../Home/Home";
import Login from "../../pages/Login";
import Logout from "../../pages/Logout";
import DRNUpload from "../DRNUpload/DRNUpload";
import MainHeader from "../PublicComponents/MainHeader";
import UnAuth from "../PublicComponents/UnAuth";
import { useUser } from "../../contexts/userContextApi";
import AdvancedSearch from "../AdvancedSearch/AdvancedSearch";
import useTelemetry from "../../opentelemetry-library/utils/useTelemetry";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import QNAHome from "../QNA/QNAHome";
import QuestionnairePage from "../QNA/QuestionnairePage";
import { useEffect } from "react";

export default function AppContent() {
  const user = useUser();
  const { headerView, setHeaderView } = useUser();
  const { telemetryEnabled, handleTelemetryValue } = useTelemetry();
  const location = useLocation();

  useEffect(() => {
    const isQuestionPage = location.pathname.startsWith(
      "/drn/questionnaire/question/"
    );

    setHeaderView(isQuestionPage);
  }, [location.pathname]);

  const startEventTrace = () => {
    handleTelemetryValue("Accept");
    return telemetryEnabled;
  };

  return (
    <>
      <MainHeader />

      <Routes>
        <Route
          path="/"
          element={<Login startEventTrace={startEventTrace} />}
        />

        <Route path="/drn" element={<AppLayout />}>
          {user?.role !== "itr_user" ? (
            <Route index element={<Navigate to="quickSearch" replace />} />
          ) : (
            <Route index element={<Navigate to="questionnaire" replace />} />
          )}

          <Route path="quickSearch" element={<QuickSearch />} />
          <Route path="uploadDrn" element={<DRNUpload />} />
          <Route path="advancedSearch" element={<AdvancedSearch />} />
          <Route path="questionnaire" element={<QNAHome />} />
          <Route path="logout" element={<Logout />} />

         <Route
           path="questionnaire/question/:orderNumber"
            element={<QuestionnairePage />}
          />
        </Route>
       
        <Route path="/UnAuthorize" element={<UnAuth />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}